import { useCallback, useEffect } from "react";
import { ExpressionValidationResultDc } from "@evergis/api";

import { validateExpression } from "../resources/layers";
import { useValidationServerError } from "./useValidationServerError";

interface ValidateExpressionState {
  data?: ExpressionValidationResultDc;
  error?: Error;
  loading?: boolean;
  typeError?: Error | null;
  clearTypeError?: VoidFunction;
}

type UseValidateExpression = [(expression: string) => Promise<void>, ValidateExpressionState];

export const useValidateExpression = (layerName: string): UseValidateExpression => {
  const [validate, { loading, error, data }] = validateExpression.use();
  const { setError } = useValidationServerError();

  const onValidate = useCallback(
    async (expression: string) => {
      await validate({
        input: {
          layerName,
          expression,
        },
      });
    },
    [layerName, validate],
  );

  useEffect(() => {
    if (data && !data.isValid) {
      setError(data);
    }
  }, [data]);

  return [onValidate, { loading, error, data }];
};
